import React, { useState, useEffect } from 'react';
import MUIDataTable from 'mui-datatables';
import InSertDataToolBar from './InSertDataToolBar';
// import Database from 'src/firebaseConfig'
import firebase from 'firebase/app';

// const fireDB = firebase.database();

const columns = ['Name', 'Opinion', 'Contents'];

const defaultData = [
  ['삼성전자(우)', 'BUY', '오너 수감 예정'],
  ['LG전자(우)', 'BUY', '저가 행진'],
  ['대우조선해양', 'SELL', '현재가 최고가 예상'],
  ['ABC', 'SELL', '신규 투자 유치 ']
];
// const defaultData = [
//   { id: 0, name: '삼성전자(우)', opinion: 'BUY', contents: '오너 수감 예정' }
// ];

const ddata = ['ABC', 'SELL', '신규 투자 유치 '];

export default function BriefingTable() {
  const [data, setData] = useState(defaultData);

  useEffect(() => {
    // api.get("/users")
    //   .then(res => {
    //     setData(res.data.data)
    //   })
    //   .catch(error=>{
    //     setErrorMessage(["Cannot load user data"])
    //     setIserror(true)
    //   })
    console.log(data);
  }, [data]);

  const getDataFromModal = records => {
    data.push(ddata);
    console.log(records);

    // firebase.initializeApp({firebaseConfig});

    // let test = fireDB.ref('/phoneNumberRef');
    // test.update('01012345678')

    var postData = {
      '01012345678': true
    };

    var updates = {};

    updates['/phoneNumberRef/'] = postData;
    var result = firebase
      .database()
      .ref()
      .update(updates);
    console.log('pushed result', result);

    // setNewData(test)
    setData(data);
  };

  // function PushSensor(value) {
  // let phone = '01098765432'
  // var postData = {
  //   phone: true
  // };
  // var newPostKey = firebase.database().ref().child('light').push().key;
  // var updates = {};
  // updates['/light/' + newPostKey] = postData;
  // var result=firebase.database().ref().update(updates);
  // console.log("pushed result", result);
  // }

  const deleteRowData = e => {
    console.log(e);
  };

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'vertical',
    search: true,
    rowsPerPage: 10,
    onRowsDelete: rowsDeleted => {
      // const idsToDelete = rowsDeleted.data.map(d => data[d.dataIndex].id); // array of all ids to to be deleted
      // http.delete(idsToDelete, res).then(window.alert('Deleted!')); // your delete request here
    },
    customToolbar: () => {
      return <InSertDataToolBar getDataFromModal={getDataFromModal} />;
    }
  };

  return (
    <MUIDataTable
      data={data}
      columns={columns}
      options={options}
      loading={true}
      onRowClick={deleteRowData}
    />
  );

  // function handleChange(newValue) {
  //   setData(newValue);
  // }
}
